import { render } from "./CometChatSenderStickerMessageBubble.vue?vue&type=template&id=252aab66"
import script from "./CometChatSenderStickerMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderStickerMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderStickerMessageBubble.vue?vue&type=style&index=0&id=252aab66&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__